var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { useNavigate } from 'react-router';

import { Translate } from "../../../../../I18N";
import { Table } from "../../../../Components/UI";

import { columnsThesauri } from "./TableComponents";












const ThesauriTable = ({ currentThesauri, setSelectedThesauri }) => {
  const navigate = useNavigate();
  const navigateToEditThesaurus = async (thesaurus) => {
    await navigate(`./edit/${thesaurus.original._id}`);
  };

  return (/*#__PURE__*/
    _jsx(Table, {
      data: currentThesauri,
      columns: columnsThesauri({ edit: navigateToEditThesaurus }),
      defaultSorting: [{ id: 'name', desc: false }],
      onChange: ({ selectedRows }) => {
        setSelectedThesauri(currentThesauri.filter((thesaurus) => thesaurus.rowId in selectedRows));
      },
      enableSelections: true,
      header: /*#__PURE__*/
      _jsx("div", { className: "flex flex-col items-start gap-1" }, void 0, /*#__PURE__*/
      _jsx("h2", { className: "text-base font-semibold text-left text-gray-900 bg-white" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Thesauri")
      )
      ) }

    ));

};


export { ThesauriTable };